import type { FC, ReactNode } from 'react';

export interface HiddenFieldGateProps {
  children?: ReactNode;
  hidden: boolean;
}

export const HiddenFieldGate: FC<HiddenFieldGateProps> = ({ hidden, children }) => {
  return hidden ? null : <>{children}</>;
};
